<div>
  <img src="/assets/icons/icon-72.webp" alt="Bandmanager App" width="72" height="72">
  <h3>{{"home-page.title" | translate}}</h3>
</div>
